import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EventCreatePage } from '@pages/events';

/** Such-Parameter Schema für die Neue-Veranstaltung-Route. */
const searchSchema = z.object({
  copyFrom: z.string().optional(),
});

/** Neue-Veranstaltung-Route (/events/new) mit optionalem ?copyFrom={eventId} Parameter. */
export const Route = createFileRoute('/_authenticated/events/new')({
  validateSearch: searchSchema,
  component: EventCreatePage,
});
